import { render, staticRenderFns } from "./deploy.vue?vue&type=template&id=61fa2070"
import script from "./deploy.vue?vue&type=script&lang=js"
export * from "./deploy.vue?vue&type=script&lang=js"
import style0 from "./deploy.vue?vue&type=style&index=0&id=61fa2070&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fa2070')) {
      api.createRecord('61fa2070', component.options)
    } else {
      api.reload('61fa2070', component.options)
    }
    module.hot.accept("./deploy.vue?vue&type=template&id=61fa2070", function () {
      api.rerender('61fa2070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/deploy.vue"
export default component.exports